import React, { useRef } from 'react'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// uuid
import uuid from 'react-uuid';

export default function ImagesUploader(props) {
    // props
    const {
        formik,

        currentSelectedImage,
        setCurrentSelectedImage
    } = props

    // refs
    const addImgInputRef = useRef(null)

    // add image change
    const handleAddImageChange = ev => {
        if (ev?.target?.files?.length) {

            let file = ev.target.files[0];

            // initializing FileReader
            let reader = new FileReader();

            // reading data from the file
            reader.readAsDataURL(file);

            // on load
            reader.onload = function (ev) {
                const imageData = {
                    id: uuid().replaceAll("-", ""),
                    src: reader.result,
                    value: file
                }

                console.log("imageData ", imageData);

                setCurrentSelectedImage(imageData) // setting the image
            };
            // on error
            reader.onerror = function () {
                console.log("error while getting file info ", reader.error);
            };
        }
    }

    // edit image
    const handleAddOrEditSelectedImage = (ev) => {
        ev.preventDefault()

        addImgInputRef.current.click()
    }

    return (
        <div className={`img-uploader-container ${formik?.touched?.isImageSelected && formik?.errors?.isImageSelected ? "has-error" : ""}`}>
            <div className="iuc-inner d-flex flex-wrap">
                {/* to select image */}
                <input
                    type="file"
                    accept="image/png, image/gif, image/jpeg"
                    hidden
                    multiple
                    ref={addImgInputRef}
                    onChange={handleAddImageChange}
                />

                {
                    /* item */
                    currentSelectedImage?.src ? (
                        <div className={`img-block position-relative`}>
                            {/* img */}
                            <div className="img-main h-100 d-flex align-items-center justify-content-center">
                                <img src={currentSelectedImage?.src} alt={`img`} className="img-fluid img-fluid-height" />
                            </div>

                            {/* options */}
                            <div className={`options position-absolute h-100 w-100 d-flex flex-wrap`}>
                                {/* edit */}
                                <div className="edit-icon d-flex ms-auto">
                                    <a href="/"
                                        className="edit st-round-btn st-btn-xs d-flex align-items-center justify-content-center me-1"
                                        title="Edit"
                                        onClick={handleAddOrEditSelectedImage}>
                                        <FeatherIcon
                                            icon="edit-2"
                                            size="14"
                                            className="icon" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    ) : (
                        // add img
                        <label
                            className={`add-img cursor-pointer ${currentSelectedImage?.src ? "has-category-image" : ""}`}
                            onClick={handleAddOrEditSelectedImage}>
                            <span className="d-flex flex-column align-items-center justify-content-center h-100 w-100 inner">
                                {/* box */}
                                <div className="icon-box d-flex align-items-center justify-content-center">
                                    <FeatherIcon
                                        icon="plus"
                                        size="20"
                                        className="icon st-text-primary position-relative" />
                                </div>
                                {/* text */}
                                <p className="st-fs-13 st-fw-600 mt-2 st-text-primary">Upload Image</p>
                            </span>
                        </label>
                    )
                }

                <p className="desc w-100 st-fs-12 position-relative" style={{top: -12}}>Recomended: 500 x 500 (W x H)</p>
            </div>
        </div>
    )
}
